export default "__VITE_PUBLIC_ASSET__ee2f4101__"